/**
 * CRichEditor
 * @author Tevin
 */
import React from 'react';
import PropTypes from 'prop-types';
import BraftEditor from 'braft-editor';
import { ContentUtils } from 'braft-utils';
import { CaretRightOutlined } from '@ant-design/icons';
import 'braft-editor/dist/index.css';
import './cRichEditor.scss';

export class CRichEditor extends React.Component {
    static propTypes = {
        // 样式名
        className: PropTypes.string,
        // 初始项值
        value: PropTypes.any,
        // 改变项值后的回调
        onChange: PropTypes.func,
        placeholder: PropTypes.string,
        // 模板变量：点击后在光标处插入 value
        placeholders: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.string.isRequired,
                label: PropTypes.string.isRequired,
            }),
        ),
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
            editorState: null,
        };
        this._data = {
            atLivinig: false,
        };
    }

    componentDidMount() {
        this._data.atLivinig = true;
        if (this.props.value) {
            this.$initValue(this.props.value);
        }
    }

    componentWillUnmount() {
        this._data.atLivinig = false;
    }

    _htmlFromEditorState(editorState) {
        return editorState
            .toHTML()
            .replace(/<p[^>]*?><\/p>/g, '<p><br/></p>')
            .replace(/ {2}/g, '&nbsp; ');
    }

    _handleChange(editorState) {
        this.setState({
            editorState: editorState,
        });
        this.props.onChange(this._htmlFromEditorState(editorState));
    }

    _placeholderExtendControls() {
        const list = this.props.placeholders;
        if (!list || !list.length) {
            return [];
        }
        return [
            'separator',
            commonProps => ({
                key: 'contract-placeholder-caption',
                type: 'button',
                title: '在光标处插入模板变量，点击右方名称插入对应占位符',
                className: 'contract-placeholder-caption',
                text: (
                    <React.Fragment>
                        <span className="contract-placeholder-toolbar-title">变量
                            <CaretRightOutlined />
                        </span>
                    </React.Fragment>
                ),
                onClick: () => { },
            }),
            ...list.map((p, index) => commonProps => ({
                key: `contract-ph-${index}`,
                type: 'button',
                text: p.label,
                title: `插入 ${p.value}`,
                className: 'contract-placeholder-chip',
                onClick: () => {
                    const { editor, editorState } = commonProps;
                    const next = ContentUtils.insertText(editorState, p.value);
                    editor.setValue(next);
                    if (typeof editor.requestFocus === 'function') {
                        editor.requestFocus();
                    }
                },
            })),
        ];
    }

    _createControls() {
        return [
            'undo',
            'redo',
            'separator',
            'bold',
            'italic',
            'underline',
            'text-color',
            'font-size',
            'separator',
            'text-indent',
            'text-align',
            'separator',
            'list-ul',
            'list-ol',
            'blockquote',
            'hr',
            'separator',
            { key: 'clear', text: <b>清空</b> },
        ];
    }

    render() {
        const { placeholder, className } = this.props;
        return (
            <span className={['c-rich-editor', className].join(' ')}>
                <BraftEditor
                    value={this.state.editorState}
                    onChange={evt => this._handleChange(evt)}
                    placeholder={placeholder}
                    controls={this._createControls()}
                    extendControls={this._placeholderExtendControls()}
                />
            </span>
        );
    }

    $initValue(content = '<p></p>') {
        if (!this._data.atLivinig) {
            return;
        }
        if (content !== '<p></p>') {
            // 替换换行策略
            content = content
                .replace(/<p[^>]*?><\/p>/g, '')
                .replace(/<p[^>]*?><br(\/)?><\/p>/g, '<p></p>');
        }
        // 需要转换
        if (content.indexOf('&lt;') >= 0) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = content;
            content = tempDiv.innerText || tempDiv.textContent;
        }
        this.setState({
            editorState: BraftEditor.createEditorState(content),
        });
    }
}
